import Asset from "../models/asset";
import Document from "../models/document";

export interface BarcodeFormItem {
  id?: number;
  companyId?: number;
  documentId?: number;
  document?: Document;
  barcode?: string;
  assetName?: string;
  asset?: Asset;
}

export interface BarcodeData {
  code: string;
  label?: string;
  assetName?: string;
}

export const convertToBarcodeData = (
  inputItems: BarcodeFormItem[]
): BarcodeData[] => {
  const outputItems: BarcodeData[] = [];

  inputItems.forEach((item) => {
    if (item.barcode !== undefined && item.barcode !== "") {
      const barcodeData: BarcodeData = {
        code: item.barcode,
        label: item.document !== undefined ? item.document.name : undefined,
        assetName: item.asset !== undefined ? item.asset.name : undefined,
      };
      outputItems.push(barcodeData);
    }
  });

  return outputItems;
};
